export default __webpack_public_path__ + "static/media/sv.64031b55.svg";